export default function registerSubFlow (lf) {
  lf.register('subflow', ({ RectNode, RectNodeModel, h }) => {
    class View extends RectNode {

      getLabelShape() {
        const { model } = this.props;
        const { x, y, width, height } = model;
        const style = model.getNodeStyle();
        return h(
            "svg",
            {
              x: x - width / 2 + 5,
              y: y - height / 2 + 5,
              width: 25,
              height: 25,
              viewBox: "0 0 1274 1024"
            },
            [

              h("path", {
                fill: style.stroke,
                d:
                    "M938.666667 725.333333a128 128 0 0 0-248.32-42.666666H640a85.333333 85.333333 0 0 1-85.333333-85.333334 128 128 0 0 0-33.28-85.333333A128 128 0 0 0 426.666667 469.333333H333.653333a128 128 0 1 0 0 85.333334H426.666667a42.666667 42.666667 0 0 1 42.666666 42.666666 170.666667 170.666667 0 0 0 170.666667 170.666667h50.346667A128 128 0 0 0 938.666667 725.333333z m-384-285.013333V426.666667a85.333333 85.333333 0 0 1 85.333333-85.333334h50.346667a128 128 0 1 0 0-85.333333H640a170.666667 170.666667 0 0 0-168.106667 143.786667 203.52 203.52 0 0 1 82.773334 40.533333z"
              })
            ]
        );
      }
      getShape() {
        const { model } = this.props;
        const { x, y, width, height, radius, properties } = model;
        const style = model.getNodeStyle();
        return h("g", {}, [
          h("rect", {
            ...style,
            x: x - width / 2,
            y: y - height / 2,
            rx:radius,
            ry: radius,
            width,
            height
          }),
          this.getLabelShape()
        ]);
      }
    }
    class Model extends RectNodeModel {
      constructor (data, graphModel) {
        super(data, graphModel)
        this.radius = 5;
      }
    }
    return {
      view: View,
      model: Model
    }
  })
}
